import {
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Typography,
} from '@mui/material'

export default function BillingMonthlyTable(props) {
  let { isUtil, fullData, devices, grandTotalMonthlyUtilization, emRate } = props

  function isNumeric(str) {
    if (typeof str != 'string') return false
    return !isNaN(str) && !isNaN(parseFloat(str))
  }

  function sanitizeValue(v) {
    return v.toString()
    if (isNumeric(v.toString())) {
      v = parseFloat(v + '')
        .toFixed(3)
        .toString()

      if (v.endsWith('.000')) {
        v = v.split('.')[0]
      }

      //do twice since could end with '0' or '00' after the decimal
      if (v.includes('.') && v.endsWith(0)) {
        v = v.substring(0, v.length - 1)
      }
      if (v.includes('.') && v.endsWith(0)) {
        v = v.substring(0, v.length - 1)
      }
    }
    return v
  }

  return (
    <>
      <h3>{isUtil ? 'Utility (KWH)' : 'Generator (KWH)'}</h3>
      <div>
        <div>
          <strong>Usage:</strong> {grandTotalMonthlyUtilization.toFixed(3)} KWH @ Rs.{' '}
          {emRate.toFixed(2)}/KWH = Rs. {(grandTotalMonthlyUtilization * emRate).toFixed(2)}
        </div>
      </div>
      <TableContainer
        sx={{
          width: '100%',
          overflowX: 'auto',
          maxHeight: '80vh',
        }}
        component={Paper}
      >
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell width={'50px'} align="center" sx={{ backgroundColor: '#F0F0F0' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                  Date
                </Typography>
              </TableCell>
              {devices &&
                devices.map((device) => (
                  <TableCell key={device} align="center" sx={{ backgroundColor: '#F0F0F0' }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                      {device}
                    </Typography>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {fullData.map((row, i) => (
              <TableRow key={i}>
                {row.map((v, j) => (
                  <TableCell key={j} align="center">
                    {i === fullData.length - 1 && (
                      <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                        {sanitizeValue(v)}
                      </Typography>
                    )}
                    {i !== fullData.length - 1 && (
                      <Typography variant="caption">
                        {sanitizeValue(v).replaceAll('-', '/')}
                      </Typography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
